import React from 'react';
import PropTypes from 'prop-types';

const Complete = (props) => {
  const {
    color = '#000',
    height = '27px',
    width = '27px',
    className = '',
  } = props;
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27 27"
      className={className}
    >
      <circle fill={color} cx="13.5" cy="13.5" r="13.5" />

      <polygon
        fill="white"
        points="11.1,19.2 6.5,14.6 7.9,13.2 11.1,16.5 19,8.6 20.3,9.9"
      />
    </svg>
  );
};
Complete.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
};

export default Complete;
